import { render, staticRenderFns } from "./bank-card.vue?vue&type=template&id=940e5f7c&scoped=true&"
import script from "./bank-card.vue?vue&type=script&lang=js&"
export * from "./bank-card.vue?vue&type=script&lang=js&"
import style0 from "./bank-card.vue?vue&type=style&index=0&id=940e5f7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940e5f7c",
  null
  
)

component.options.__file = "bank-card.vue"
export default component.exports